import React from 'react';
import { DonationList } from '../DonationList';
import type { Donation } from '../../../types/leaderboard';
import styles from './DonationListWidget.module.css';

export type DonationListMode = 'top' | 'recent';

interface DonationListWidgetProps {
  title: string;
  donations: Donation[];
  mode: DonationListMode;
  onModeChange: (mode: DonationListMode) => void;
  maxItems?: number;
  viewAllLink?: string;
  viewAllText?: string;
  formatTimeElapsed: (date: string) => string;
  modeToggleLabels?: {
    top: string;
    recent: string;
  };
  emptyStateMessage?: string;
  showRank?: boolean;
  onDonationClick?: (donation: Donation) => void;
  isLoading?: boolean;
}

export const DonationListWidget: React.FC<DonationListWidgetProps> = ({
  title,
  donations,
  mode,
  onModeChange,
  maxItems = 10,
  viewAllLink,
  viewAllText,
  formatTimeElapsed,
  modeToggleLabels = { top: 'Top', recent: 'Recent' },
  emptyStateMessage,
  showRank = false,
  onDonationClick,
  isLoading = false,
}) => {
  const handleModeClick = (newMode: DonationListMode) => {
    if (mode !== newMode) {
      onModeChange(newMode);
    }
  };

  return (
    <div className={styles.leaderboardWidget}>
      <div className={styles.leaderboardWidgetHeader}>
        <h3>{title}</h3>
        <div className={styles.fundraiserTypeToggle}>
          <button
            onClick={() => handleModeClick('top')}
            className={`${styles.typeButton} ${
              mode === 'top' ? styles.typeButtonActive : ''
            }`}
          >
            {modeToggleLabels.top}
          </button>
          <button
            onClick={() => handleModeClick('recent')}
            className={`${styles.typeButton} ${
              mode === 'recent' ? styles.typeButtonActive : ''
            }`}
          >
            {modeToggleLabels.recent}
          </button>
        </div>
      </div>
      <DonationList
        donations={donations}
        maxItems={maxItems}
        viewAllLink={viewAllLink}
        viewAllText={viewAllText}
        formatTimeElapsed={formatTimeElapsed}
        emptyStateMessage={emptyStateMessage}
        showRank={showRank}
        onDonationClick={onDonationClick}
        isLoading={isLoading}
      />
    </div>
  );
};
